import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { history } from '../helpers/history';
import { userAuthorizedSaga } from '../../redux/saga/loginServiceSelector';

export { PrivateRoute };

function PrivateRoute({ children }) {
    const userAuth = useSelector(userAuthorizedSaga) || sessionStorage.getItem('merchantAuth') === 'true';
    if (!userAuth) {
        return <Navigate to='/' state={{ from: history.location }} />
    }
    return children;
}